var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoOrders = function SvgIconNoOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40 36v8h24v-8h4.013C69.11 36 70 36.89 70 37.987v32.026C70 71.11 69.11 72 68.013 72H35.987A1.987 1.987 0 0 1 34 70.013V37.987c0-1.098.89-1.987 1.987-1.987zm6 26h-4v4h4zm0-6h-4v4h4zm0-6h-4v4h4zm14-18v8H44v-8z"
  })));
};
export default SvgIconNoOrders;